import { render, staticRenderFns } from "./HistoricalTable.vue?vue&type=template&id=9b50d0b4"
import script from "./HistoricalTable.vue?vue&type=script&lang=js"
export * from "./HistoricalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports